import { Component, OnInit } from '@angular/core';
import { StoreNotificationService } from '@services/cleanfill-core/store-notifications/store-notification.service';
import { SidenavService } from '@widgets/site-common/navbar/side-nav/side-nav.service';

@Component({
  selector: 'notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss']
})
export class NotificationListComponent implements OnInit {
  constructor(public notificationService: StoreNotificationService, private sidenavService: SidenavService) {}

  totalNotifications: number;

  ngOnInit() {
    console.log('zz not2', this.notificationService.totalNewCount$);
  }
  onClose() {
    this.sidenavService.close();
  }
}
